import React from "react";
import { Field } from "../../containers/QueryBuilder/types/Field";
import { Query, QueryField, QueryResult, QueryStatus } from "../../containers/QueryBuilder/types/Query";
import { UserQuery } from "../../containers/QueryBuilder/types/UserQuery";
import {ChartOptions, ChartResults} from "../../actions/queryBuilderApi";
import {QueryMetaData} from "../../containers/QueryBuilder/types/QueryMetaData";

export function testQueryBuilderContext(): QueryBuilderContextType {
    const field = {field: {code: "admission", opt: "identifier"}} as CurrentField
    return {
        id: undefined,
        setId: (id: string) => {
        },
        userQuery: emptyUserQuery(),
        setUserQuery: (userQuery: UserQuery) => {
        },
        queryResult: undefined,
        setQueryResult: (queryResult: QueryResult) => {
        },
        dataset: "IP",
        setDataset: (dataset: string) => {
        },
        currentField: field,
        setCurrentField: (field: CurrentField) => {
        },
        isValueModalOpen: true,
        setIsValueModalOpen: (open: boolean) => {
        },
        isFilterModalOpen: false,
        setIsFilterModalOpen: (open: boolean) => {
        },
        isExportModalOpen: false,
        setIsExportModalOpen: (open: boolean) => {
        },
        onFilterFinish: undefined,
        setOnFilterFinish: (fn: OnFilterFinishType) => {
        },
        defaultQueryVisualisationResults: emptyChartResults(),
        setDefaultQueryVisualisationResults: (defaultQueryVisualisationResults: ChartResults) => {
        },
    } as QueryBuilderContextType
}

export type OnFilterFinishType = undefined | ((fn: Query) => void)

export type CurrentField = undefined | { field: Field, queryField?: QueryField }

export const emptyQuery = (): Query => {
    return {
        columns: [],
        rows: [],
        values: [],
        filters: [],
        filterLabels: [],
    }
}

export const emptyUserQuery = (): UserQuery => {
    return {
        queryId: '',
        query: emptyQuery(),
        createdOn: 0,
        loginId: '',
        category: null,
        label: null,
        saved: false,
        shared: false,
        favourite: null,
        sharedUser: null,
        totalTimes: null,
        status: QueryStatus.NOT_READY,
        largeExport: false,
        exportFileSizeOverLimit: false,
        uploadedToS3: false,
        uploadedOn: 0,
        s3FileName: ''
    }
}

export const emptyChartResults = (): ChartResults => {
    return {
        labels: [],
        values: []
    }
}

export interface QueryBuilderContextType {
    id: string | undefined
    setId: (id: string | undefined) => void
    cohortId: number | null
    isCohortAnalyser: boolean
    userQuery: UserQuery
    setUserQuery: (userQuery: UserQuery) => void
    queryResult: QueryResult | undefined
    setQueryResult: (queryResult: QueryResult | undefined) => void
    dataset: string
    setDataset: (dataset: string) => void
    currentField: CurrentField
    setCurrentField: (currentField: CurrentField) => void
    isValueModalOpen: boolean
    setIsValueModalOpen: (open: boolean) => void
    isFilterModalOpen: boolean
    setIsFilterModalOpen: (open: boolean) => void
    isExportModalOpen: boolean
    setIsExportModalOpen: (open: boolean) => void
    onFilterFinish: OnFilterFinishType
    setOnFilterFinish: (fn: OnFilterFinishType) => void
    defaultQueryVisualisationOptions: ChartOptions | undefined
    setDefaultQueryVisualisationOptions: (defaultQueryVisualisationOptions: ChartOptions | undefined) => void
    defaultQueryVisualisationResults: ChartResults | undefined
    setDefaultQueryVisualisationResults: (defaultQueryVisualisationResults: ChartResults | undefined) => void
    queryMetaData: QueryMetaData | undefined
    setQueryMetaData: (queryMetaData: QueryMetaData | undefined) => void
}

export const QueryBuilderContext = React.createContext<QueryBuilderContextType | undefined>(undefined)